// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ecd25a43","453":"b8b69ee0","697":"2c010357","715":"92de7ae3","776":"c0e2fd3d","837":"0efa59b3","879":"4e661ae3","914":"73a9e769"}[chunkId] + ".chunk.js";
};